import apiClient from './api'; // your axios instance

async function createBusinessCategory(data) {
  try {
    const response = await apiClient.post('/create-business-category', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  } catch (error) {
    if (error.response) return error.response;
    throw error;
  }
}

async function updateBusinessCategory(categoryId, data) {
  try {
    const response = await apiClient.post(`/update-business-category/${categoryId}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  } catch (error) {
    if (error.response) return error.response;
    throw error;
  }
}

async function deleteBusinessCategory(categoryId) {
  try {
    const response = await apiClient.post(`/delete-business-category/${categoryId}`);
    return response;
  } catch (error) {
    if (error.response) return error.response;
    throw error;
  }
}

export { createBusinessCategory, updateBusinessCategory, deleteBusinessCategory };
